import { SVGProps } from 'react';

const SvgBipolarDisorder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <g clipPath="url(#Bipolar_disorder_svg__a)">
      <path
        fill="#FC3"
        d="M25.544 3.16A15.927 15.927 0 0 0 15.999 0C9.144 0 3.296 4.312 1.02 10.372v11.252a16.01 16.01 0 0 0 1.805 3.452v-14.34a.952.952 0 1 1 1.904 0v16.62c.576.572 1.2 1.1 1.856 1.58v-14.32a.952.952 0 1 1 1.904 0V28.9a.952.952 0 0 1-.604.884c.58.344 1.188.652 1.812.92.328-.396.527-.9.527-1.452V5.9a.952.952 0 1 1 1.904 0v23.356a4.12 4.12 0 0 1-.58 2.112c.636.184 1.284.332 1.952.436a.93.93 0 0 1 .56-.184h1.017a2.923 2.923 0 0 0 2.92-2.92V5.392a.952.952 0 1 1 1.904 0v23.304c0 1.16-.412 2.224-1.096 3.056a15.892 15.892 0 0 0 6.768-2.924 5.812 5.812 0 0 1-.02-.46V3.16h-.008Zm-9.6 25.732a.952.952 0 1 1-1.905 0V2.024a.952.952 0 1 1 1.905 0V28.892Zm7.611.012a.952.952 0 1 1-1.904 0v-16.86a.952.952 0 1 1 1.904 0V28.904ZM32 16c0-1.78-.296-3.488-.832-5.088v10.176c.536-1.6.832-3.308.832-5.088ZM29.268 24.948V7.052a16.208 16.208 0 0 0-1.82-2.228v22.348a16.261 16.261 0 0 0 1.82-2.228v.004Z"
      />
      <path
        fill="#FB3"
        d="M0 16c0 1.98.364 3.876 1.02 5.628V10.372A16.002 16.002 0 0 0 0 16Z"
      />
      <path
        fill="#FFD45C"
        d="M8.484 28.9V14.616a.952.952 0 1 0-1.904 0v14.316c.416.304.848.588 1.296.852a.952.952 0 0 0 .604-.884h.004Z"
      />
      <path
        fill="#FFDE83"
        d="M14.996 1.072a.952.952 0 0 0-.952.952v26.864a.952.952 0 1 0 1.904 0V2.024a.952.952 0 0 0-.952-.952Z"
      />
      <path
        fill="#FFE9AB"
        d="M22.608 11.092a.952.952 0 0 0-.952.952V28.9a.952.952 0 1 0 1.904 0V12.044a.952.952 0 0 0-.952-.952Z"
      />
      <path
        fill="#FFDE83"
        d="M31.168 21.088V10.912a15.986 15.986 0 0 0-1.904-3.86v17.896c.8-1.184 1.44-2.48 1.904-3.86Z"
      />
      <path
        fill="#FFD45C"
        d="M19.892 5.392a.952.952 0 1 0-1.904 0v23.304a2.923 2.923 0 0 1-2.92 2.92h-1.016c-.208 0-.4.072-.56.184a16.082 16.082 0 0 0 5.304-.052 4.796 4.796 0 0 0 1.096-3.056v-23.3Z"
      />
      <path
        fill="#FFDE83"
        d="M3.776 9.784a.952.952 0 0 0-.952.952v14.34c.564.816 1.2 1.58 1.904 2.276V10.736a.952.952 0 0 0-.952-.952Z"
      />
      <path
        fill="#FFE9AB"
        d="M12.12 5.9a.952.952 0 1 0-1.903 0v23.356c0 .552-.2 1.06-.529 1.452.6.256 1.216.476 1.848.66.369-.62.58-1.34.58-2.112V5.9h.005Z"
      />
      <path
        fill="#FB3"
        d="M27.448 27.172V4.828a15.748 15.748 0 0 0-1.904-1.668v25.212c0 .156.008.308.02.46.672-.5 1.3-1.056 1.884-1.652v-.008Z"
      />
    </g>
    <defs>
      <clipPath id="Bipolar_disorder_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBipolarDisorder;
